module.exports = __webpack_public_path__ + "img/pilot21.d5c79a25.png";